import React from "react";
import "./TopPropertyStyles/PropertyCard.css";
import { Link } from "react-router-dom";
import api from "../../../api/axios";

const PropertyCard = ({ property }) => {
  // Extract primary photo or use placeholder
  const getPropertyImage = () => {
    if (!property.photos || property.photos.length === 0) {
      return "https://via.placeholder.com/400x300?text=No+Image"; 
    }
    const photo = property.photos[0];
    if (photo.file_path.startsWith("http")) {
      return photo.file_path;
    }
    return `${api.defaults.baseURL}/${photo.file_path}`;
  };

  const propertyImage = getPropertyImage();

  // Construct location string
  const locationString = property.location
    ? `${property.location.area || ""}, ${property.location.city || ""}`
    : "Location Unavailable";

  // Safe checks for values
  const floors = property.total_floors || "N/A";
  const units = property.total_units || "0";
  const area = property.area_sq_ft
    ? parseFloat(property.area_sq_ft).toLocaleString()
    : "N/A";

  // Calculate price if not already mapped
  const displayPrice = property.price
    ? Number(property.price).toLocaleString()
    : "0";

  return (
    <div className="property-card">
      {/* Property Image */}
      <div className="property-image-container">
        <img
          src={propertyImage}
          alt={property.name}
          className="property-image"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/400x300?text=Image+Error";
          }}
        />
        {/* Status Badge */}
        <div
          className={`status-badge ${property.status?.status_type?.toLowerCase() || "available"}`} 
        >
          {property.status?.status_type || "Available"}
        </div>
      </div>

      {/* Property Details */}
      <div className="property-details">
        {/* Name and Type */}
        <div className="property-header">
          <h3 className="property-name">{property.name}</h3>
          <span className="property-type">
            {property.type?.name || "Property"}
          </span>
        </div>

        {/* Location */}
        <div className="property-location">
          <svg
            className="location-icon"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clipRule="evenodd"
            />
          </svg>
          {locationString}
        </div>

        {/* Building Information Grid */}
        <div className="property-info-grid">
          <div className="info-item">
            <span className="info-label">Floors</span>
            <span className="info-value">{floors}</span>
          </div>

          <div className="info-item">
            <span className="info-label">Total Units</span>
            <span className="info-value">{units}</span>
          </div>

          <div className="info-item">
            <span className="info-label">Area</span>
            <span className="info-value">{area} sqft</span>
          </div>

          <div className="info-item">
            <span className="info-label">Class</span>
            <span className="info-value">
              {property.type?.class || "General"}
            </span>
          </div>
        </div>

        {/* Price and Details Action */}
        <div className="property-footer">
          {/* <div className="property-price">
            <span className="price-label">Starting from</span>
            <span className="price-value">BDT {displayPrice}</span>
          </div> */}
          <Link to={`/greenland/properties/${property.id}`} className="view-details-btn" id="view-details-btn-bg">
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
